/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pascalCase from 'pascal-case';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FormattedDate } from 'react-intl';

import MoreInfo from '../partials/MoreInfo';

import styles from '../../../styles/cards/news.scss';

const propTypes = {
    title: PropTypes.string,
    summary: PropTypes.string,
    url: PropTypes.string,
    date: PropTypes.string,
    image: PropTypes.string,
    thumbnailSmall: PropTypes.string,
    className: PropTypes.string,
    direction: PropTypes.oneOf(['left', 'right']),
    mobile: PropTypes.bool,
};

const defaultProps = {
    title: null,
    summary: null,
    url: null,
    date: null,
    image: null,
    thumbnailSmall: null,
    className: null,
    direction: 'left',
    mobile: false,
};

const NewsCard = ({
    title,
    summary,
    url,
    image,
    thumbnailSmall,
    date,
    className,
    direction,
    mobile,
}) => {
    const colImage =
        image !== null ? (
            <div
                className={classNames({
                    [styles.col]: true,
                    [styles.colImage]: true,
                    [styles[`col${pascalCase(direction)}`]]: true,
                })}
            >
                <div className={styles.imageContainer}>
                    {image !== null || thumbnailSmall !== null ? (
                        <Link
                            to={url || ''}
                            className={styles.image}
                            style={{
                                backgroundImage: `url("${thumbnailSmall || image}")`,
                            }}
                        />
                    ) : null}
                </div>
            </div>
        ) : null;

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles[direction]]: true,
                [className]: className !== null,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.cols}>
                    {(direction === 'left' && image !== null) || mobile ? colImage : null}
                    <div
                        className={classNames({
                            [styles.col]: true,
                            [styles.colLabel]: true,
                            [styles.colLabelRight]: direction === 'left',
                            [styles.colLabelLeft]: direction === 'right',
                            [styles.noImage]: image === null,
                        })}
                    >
                        <div className={styles.label}>
                            {date !== null ? (
                                <div className={styles.date}>
                                    <FormattedDate
                                        value={moment(date, 'YYYY-MM-DD HH:mm:ss').toDate()}
                                        year="numeric"
                                        month="long"
                                        day="numeric"
                                    />
                                </div>
                            ) : null}

                            {title !== null ? (
                                <h4 className={styles.title}>
                                    <Link to={url}>{title}</Link>
                                </h4>
                            ) : null}

                            {summary !== null ? (
                                <div className={styles.summary}>{summary}</div>
                            ) : null}

                            {url !== null ? (
                                <div className={styles.link}>
                                    <MoreInfo
                                        label={{
                                            id: 'content.more',
                                            defaultMessage: 'More',
                                        }}
                                        link={url}
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {direction === 'right' && !mobile && image !== null ? colImage : null}
                </div>
            </div>
        </div>
    );
};

NewsCard.propTypes = propTypes;
NewsCard.defaultProps = defaultProps;

export default NewsCard;



// WEBPACK FOOTER //
// ./js/components/cards/News.jsx